
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import ChallengeForum from '@/components/Challenges/tabs/forum/ChallengeForum.vue';
  import ChallengeForumTopic from '@/components/Challenges/tabs/forum/ChallengeForumTopic.vue';
  import ChallengeForumTopicForm from '@/components/Challenges/tabs/forum/ChallengeForumTopicForm.vue';
  import {TopicEvents} from '@/models/topic.model';
  import {challengeModule, forumState} from '@/utils/store-acessor';
  import {ChallengeModel} from '@/models/challenge.model';
  import ConfirmDialog from '@/components/Shared/ConfirmDialog.vue';

  @Component({
    components: {
      ConfirmDialog,
      ChallengeForumTopicForm,
      ChallengeForumTopic,
      ChallengeForum
    }
  })
  export default class ChallengeForumTab extends Vue {
    @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel | null;
    loading = false;
    topicEvents: TopicEvents = {
      topic: undefined,
      add: false,
      edit: false,
      remove: false,
      show: false,
      showTable: true
    };

    async mounted() {
      try {
        if (this.challenge?.id) {
          await forumState.fetchAll({challengeId: this.challenge.id});
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    }

    onDestroyTopic(value: TopicEvents) {
      if (!this.challenge?.id) {
        return;
      }
      const topic = value.topic;
      if (topic?.id) {
        forumState.destroyTopic({
          challengeId: this.challenge.id,
          topicId: topic.id
        })
      }
      this.topicEvents = {showTable: true}
    }
  }
